import React, { useRef, useState } from "react";
import Modal from "../../../Base/Modal";
import Amount from "../../../Base/Amount";
import DatePicker from "react-datepicker";
import { webBaseURL } from "../../../utils/config";
import { copyIcon } from "../../../Base/SVG";
import { useNavigate } from "react-router";
import { FaCopy, FaWhatsapp, FaTwitter, FaTelegram ,FaCheckCircle} from "react-icons/fa";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

export default function CopyModal({ onClose, invoiceLinkId }) {
  const [copied, setCopied] = useState(null);
  const navigate = useNavigate();

  const copyBtn = async (data) => {
    try {
      await navigator.clipboard.writeText(data);
      setCopied(data);
      setTimeout(() => {
        setCopied(null);
      }, 2000); // Show the tick icon for 5 seconds
    } catch (error) {
      console.error("Failed to copy text:", error);
    }
  };

  const whatsappShareText = `Hi! I’d like to get paid through Paylink: ${webBaseURL}/landing?invoice=${invoiceLinkId}`;

  const handleWhatsappShare = () => {
    const encodedText = encodeURIComponent(whatsappShareText);
    const whatsappShareUrl = `https://wa.me/?text=${encodedText}`;
    window.open(whatsappShareUrl, "_blank");
  };
  const shareOnFacebook = () => {
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      whatsappShareText
    )}`;
    window.open(facebookShareUrl, "_blank");
  };
  const shareOnTelegram = () => {
    const encodedText = encodeURIComponent(whatsappShareText);
    const telegramShareUrl = `https://t.me/share/url?url=${encodedText}`;
    window.open(telegramShareUrl, "_blank");
  };

  const shareOnTwitter = () => {
    const encodedText = encodeURIComponent(whatsappShareText);
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodedText}`;
    window.open(twitterShareUrl, "_blank");
  };

  return (
    <Modal close={onClose} showCloseIcon={false} addClass={"customModal"}>
      <div
        className="modal__invoice"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <img
            style={{
              width: "76px",
              height: "auto",
              margin: "0 auto",
              display: "block",
              marginBottom: "15px",
            }}
            src={process.env.PUBLIC_URL + "/images/tickIcon.png"}
            alt="congrats"
          />
          <h4
            style={{
              marginBottom: "20px",
              color: "#fff",
              fontWeight: 800,
              letterSpacing: "-1.5px",
              fontSize: "27px",
            }}
          >
            Payment Request Created!
          </h4>

          <p
            style={{
              marginBottom: "20px",
            }}
          >
            Copy the link below or share it with the payer through one of the
            social media apps below
          </p>
          <p style={{ marginRight: "auto" }}>Link</p>

          <div
            style={{
              position: "relative",
              display: ["-webkit-box", "-ms-flexbox", "flex"],
              msFlexWrap: "wrap",
              flexWrap: "wrap",
              WebkitBoxAlign: "stretch",
              msFlexAlign: "stretch",
              alignItems: "stretch",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                class="form-control"
                value={`https://${webBaseURL}/landing?invoice=${invoiceLinkId}`}
                aria-label="Payment Link"
                aria-describedby="basic-addon2"
                style={{
                  fontSize: "12px",
                  width: "90%",
                  height: "36px",
                  borderRadius: "3px",
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                  paddingLeft: "10px",
                  color: "#495057",
                }}
              />
              <button
                onClick={() =>
                  copyBtn(`${webBaseURL}/landing?invoice=${invoiceLinkId}`)
                }
                style={{
                  background: "none",
                  border: "1px solid #6c757d",
                  height: "36px",
                  padding: "8px",
                  borderRight: "0px",
                  cursor: "pointer",
                }}
              >
                {copied ? (
                  <FaCheckCircle size={"18px"} fill="#17a2b8" />
                ) : (
                  <FaCopy size={"15px"} fill="#17a2b8" />
                )}
              </button>

              <button
                onClick={() => {
                  const newTab = window.open(
                    `/landing?invoice=${invoiceLinkId}`,
                    "_blank"
                  );
                  newTab.focus();
                }}
                style={{
                  background: "none",
                  border: "1px solid #6c757d",
                  height: "36px",
                  padding: "8px",
                  borderRigtRadius: "3px",
                  cursor: "pointer",
                }}
              >
                <FaArrowUpRightFromSquare size={"15px"} fill="#17a2b8" />
              </button>
            </div>
          </div>
          <p style={{ marginRight: "auto", marginTop: "15px" }}>Media</p>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <button
              onClick={handleWhatsappShare}
              style={{
                padding: "10px",
                border: "1px solid #17a2b8",
                borderRadius: "10px",
                width: "69px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "none",
                cursor: "pointer",
              }}
            >
              <FaWhatsapp size={"22px"} fill="#17a2b8" />
            </button>

            <button
              onClick={shareOnTwitter}
              style={{
                padding: "10px",
                border: "1px solid #17a2b8",
                borderRadius: "10px",
                width: "69px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "none",
                cursor: "pointer",
              }}
            >
              <FaTwitter size={"22px"} fill="#17a2b8" />
            </button>

            <button
              onClick={shareOnTelegram}
              style={{
                padding: "10px",
                border: "1px solid #17a2b8",
                borderRadius: "10px",
                width: "69px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "none",
                cursor: "pointer",
              }}
            >
              <FaTelegram size={"22px"} fill="#17a2b8" />
            </button>
          </div>
          <div className="btn bg-transparent lineHeight btn-block">
            <button
              className="col-12 btn btn-primary btn-lg paylinkButton topMargin"
              onClick={() => {
                onClose();
              }}
              type="button"
              style={{
                backgroundColor: "#ff5757",
                display: "block",
                width: "400px",
                fontSize: "1.25rem",
                padding: "1rem",
                border: "1px solid #ff5757",
                borderRadius: "15px",
                color: "#fff",
                cursor: "pointer",
                marginTop: "2rem",
                fontWeight: "bold",
                height: "50px",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
